export type { TTSOptions, TTSResult } from './tts';
export type { STTOptions, STTResult } from './stt';
export type { LLMMessage, LLMOptions, LLMResult } from './llm';
export type { VoiceAIConfig } from './client';
export type { SignupOptions, LoginOptions, AccountInfo } from './auth';

export type AudioFormat = 'mp3' | 'wav' | 'aac' | 'flac' | 'ogg' | 'pcm';

export type TTSModel = 
  | 'vui'
  | 'orpheus'
  | 'orpheus-indic'
  | 'koroko'
  | 'xtts-v2'
  | 'mars6'
  | 'elevenlabs/multi-v2'
  | 'elevenlabs/turbo-v2-5'
  | 'elevenlabs/v3'
  | 'elevenlabs/ttv-v3'
  | 'elevenlabs/flash-v2-5'
  | 'twi-speecht5';

export type STTModel = 
  | 'whisper-v3'
  | 'kyutai'
  | 'general';

export type LLMModel = 
  | 'llama-4-scout'
  | 'general';